module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("生徒選択\n    "), _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }), _vm._v("ソート"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  }), _vm._v(" "), _c('span', [(this.sortColumn2 === 'id') ? [_vm._v("ID")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'family_name') ? [_vm._v("家庭")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'family_kana') ? [_vm._v("かな")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'name') ? [_vm._v("生徒")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'kana') ? [_vm._v("かな")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'grade') ? [_vm._v("学年")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'pref') ? [_vm._v("都道府県")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'address') ? [_vm._v("住所")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'tel1') ? [_vm._v("TEL1")] : _vm._e(), _vm._v(" "), (this.sortColumn2 === 'created_at') ? [_vm._v("作成日")] : _vm._e(), _vm._v("\n       : " + _vm._s(_vm.sortState2) + "\n    ")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "index-box StudentfilesIndex",
    on: {
      "scroll": _vm.offset
    }
  }, [_c('table-c', [_c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.id),
      expression: "search2.id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "検索"
    },
    domProps: {
      "value": (_vm.search2.id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.family_name),
      expression: "search2.family_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.family_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "family_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.family_kana),
      expression: "search2.family_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.family_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "family_kana", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.name),
      expression: "search2.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.kana),
      expression: "search2.kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "kana", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.grade,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable2()
      }
    },
    model: {
      value: (_vm.watchSearch2.grade),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch2, "grade", $$v)
      },
      expression: "watchSearch2.grade"
    }
  })], 1), _vm._v(" "), _c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.pref,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable2()
      }
    },
    model: {
      value: (_vm.watchSearch2.pref),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch2, "pref", $$v)
      },
      expression: "watchSearch2.pref"
    }
  })], 1), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.address),
      expression: "search2.address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.address)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.tel1),
      expression: "search2.tel1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.tel1)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "tel1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.created_at),
      expression: "search2.created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "created_at", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_id),
      expression: "search2.not_id"
    }],
    attrs: {
      "type": "text",
      "placeholder": "除外"
    },
    domProps: {
      "value": (_vm.search2.not_id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_family_name),
      expression: "search2.not_family_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_family_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_family_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_family_kana),
      expression: "search2.not_family_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_family_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_family_kana", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_name),
      expression: "search2.not_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_kana),
      expression: "search2.not_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_kana", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.grade,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable2()
      }
    },
    model: {
      value: (_vm.watchSearch2.not_grade),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch2, "not_grade", $$v)
      },
      expression: "watchSearch2.not_grade"
    }
  })], 1), _vm._v(" "), _c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.pref,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable2()
      }
    },
    model: {
      value: (_vm.watchSearch2.not_pref),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch2, "not_pref", $$v)
      },
      expression: "watchSearch2.not_pref"
    }
  })], 1), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_address),
      expression: "search2.not_address"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_address)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_tel1),
      expression: "search2.not_tel1"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_tel1)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_tel1", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search2.not_created_at),
      expression: "search2.not_created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search2.not_created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable2()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search2, "not_created_at", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("id")
      }
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("family_name")
      }
    }
  }, [_vm._v("家庭")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("family_kana")
      }
    }
  }, [_vm._v("かな")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("name")
      }
    }
  }, [_vm._v("生徒")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("kana")
      }
    }
  }, [_vm._v("かな")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("grade")
      }
    }
  }, [_vm._v("学年")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("pref")
      }
    }
  }, [_vm._v("都道府県")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("address")
      }
    }
  }, [_vm._v("住所")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("tel1")
      }
    }
  }, [_vm._v("TEL1")]), _vm._v(" "), _c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort2("created_at")
      }
    }
  }, [_vm._v("作成日")])], 1), _vm._v(" "), _vm._l((_vm.orderedStudents), function(student) {
    return _c('tr-c', {
      key: student.id,
      attrs: {
        "slot": "tr-td"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.getId(student)
        }
      },
      slot: "tr-td"
    }, [(_vm.studentfile.student_id === student.id) ? [_c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.id))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.family.f_name) + " " + _vm._s(student.family.l_name))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.family.f_name_kana) + " " + _vm._s(student.family.l_name_kana))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.f_name) + " " + _vm._s(student.l_name))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.f_name_kana) + " " + _vm._s(student.l_name_kana))]), _vm._v(" "), [(student.grade === 0) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (student.grade === 1) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("1")]) : _vm._e(), _vm._v(" "), (student.grade === 2) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("2")]) : _vm._e(), _vm._v(" "), (student.grade === 3) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("3")]) : _vm._e(), _vm._v(" "), (student.grade === 4) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("4")]) : _vm._e(), _vm._v(" "), (student.grade === 5) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("5")]) : _vm._e(), _vm._v(" "), (student.grade === 6) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("6")]) : _vm._e()], _vm._v(" "), [(student.family.pref === 0) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (student.family.pref === 1) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("北海道")]) : _vm._e(), _vm._v(" "), (student.family.pref === 2) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("青森県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 3) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("秋田県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 4) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("岩手県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 5) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("山形県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 6) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("宮城県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 7) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("福島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 8) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("栃木県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 9) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("山梨県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 10) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("群馬県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 11) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("茨城県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 12) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("千葉県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 13) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("埼玉県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 14) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("東京都")]) : _vm._e(), _vm._v(" "), (student.family.pref === 15) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("神奈川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 16) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("静岡県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 17) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("長野県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 18) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("愛知県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 19) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("岐阜県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 20) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("新潟県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 21) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("富山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 22) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("石川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 23) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("福井県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 24) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("滋賀県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 25) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("京都府")]) : _vm._e(), _vm._v(" "), (student.family.pref === 26) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("三重県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 27) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("和歌山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 28) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("奈良県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 29) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("大阪府")]) : _vm._e(), _vm._v(" "), (student.family.pref === 30) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("兵庫県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 31) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("鳥取県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 32) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("島根県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 33) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("岡山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 34) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("広島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 35) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("山口県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 36) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("高知県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 37) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("徳島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 38) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("香川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 39) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("愛媛県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 40) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("福岡県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 41) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("佐賀県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 42) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("長崎県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 43) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("熊本県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 44) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("宮崎県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 45) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("大分県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 46) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("鹿児島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 47) ? _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v("沖縄県")]) : _vm._e()], _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.family.address1) + _vm._s(student.family.address2))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.family.tel1))]), _vm._v(" "), _c('td-c', {
      staticClass: "clicked"
    }, [_vm._v(_vm._s(student.created_at.substring(0, 10)))])] : _vm._e(), _vm._v(" "), (_vm.studentfile.student_id !== student.id) ? [_c('td-c', [_vm._v(_vm._s(student.id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.family.f_name) + " " + _vm._s(student.family.l_name))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.family.f_name_kana) + " " + _vm._s(student.family.l_name_kana))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.f_name) + " " + _vm._s(student.l_name))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.f_name_kana) + " " + _vm._s(student.l_name_kana))]), _vm._v(" "), [(student.grade === 0) ? _c('td-c', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (student.grade === 1) ? _c('td-c', [_vm._v("1")]) : _vm._e(), _vm._v(" "), (student.grade === 2) ? _c('td-c', [_vm._v("2")]) : _vm._e(), _vm._v(" "), (student.grade === 3) ? _c('td-c', [_vm._v("3")]) : _vm._e(), _vm._v(" "), (student.grade === 4) ? _c('td-c', [_vm._v("4")]) : _vm._e(), _vm._v(" "), (student.grade === 5) ? _c('td-c', [_vm._v("5")]) : _vm._e(), _vm._v(" "), (student.grade === 6) ? _c('td-c', [_vm._v("6")]) : _vm._e()], _vm._v(" "), [(student.family.pref === 0) ? _c('td-c', [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (student.family.pref === 1) ? _c('td-c', [_vm._v("北海道")]) : _vm._e(), _vm._v(" "), (student.family.pref === 2) ? _c('td-c', [_vm._v("青森県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 3) ? _c('td-c', [_vm._v("秋田県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 4) ? _c('td-c', [_vm._v("岩手県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 5) ? _c('td-c', [_vm._v("山形県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 6) ? _c('td-c', [_vm._v("宮城県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 7) ? _c('td-c', [_vm._v("福島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 8) ? _c('td-c', [_vm._v("栃木県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 9) ? _c('td-c', [_vm._v("山梨県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 10) ? _c('td-c', [_vm._v("群馬県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 11) ? _c('td-c', [_vm._v("茨城県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 12) ? _c('td-c', [_vm._v("千葉県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 13) ? _c('td-c', [_vm._v("埼玉県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 14) ? _c('td-c', [_vm._v("東京都")]) : _vm._e(), _vm._v(" "), (student.family.pref === 15) ? _c('td-c', [_vm._v("神奈川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 16) ? _c('td-c', [_vm._v("静岡県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 17) ? _c('td-c', [_vm._v("長野県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 18) ? _c('td-c', [_vm._v("愛知県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 19) ? _c('td-c', [_vm._v("岐阜県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 20) ? _c('td-c', [_vm._v("新潟県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 21) ? _c('td-c', [_vm._v("富山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 22) ? _c('td-c', [_vm._v("石川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 23) ? _c('td-c', [_vm._v("福井県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 24) ? _c('td-c', [_vm._v("滋賀県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 25) ? _c('td-c', [_vm._v("京都府")]) : _vm._e(), _vm._v(" "), (student.family.pref === 26) ? _c('td-c', [_vm._v("三重県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 27) ? _c('td-c', [_vm._v("和歌山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 28) ? _c('td-c', [_vm._v("奈良県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 29) ? _c('td-c', [_vm._v("大阪府")]) : _vm._e(), _vm._v(" "), (student.family.pref === 30) ? _c('td-c', [_vm._v("兵庫県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 31) ? _c('td-c', [_vm._v("鳥取県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 32) ? _c('td-c', [_vm._v("島根県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 33) ? _c('td-c', [_vm._v("岡山県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 34) ? _c('td-c', [_vm._v("広島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 35) ? _c('td-c', [_vm._v("山口県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 36) ? _c('td-c', [_vm._v("高知県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 37) ? _c('td-c', [_vm._v("徳島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 38) ? _c('td-c', [_vm._v("香川県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 39) ? _c('td-c', [_vm._v("愛媛県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 40) ? _c('td-c', [_vm._v("福岡県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 41) ? _c('td-c', [_vm._v("佐賀県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 42) ? _c('td-c', [_vm._v("長崎県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 43) ? _c('td-c', [_vm._v("熊本県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 44) ? _c('td-c', [_vm._v("宮崎県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 45) ? _c('td-c', [_vm._v("大分県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 46) ? _c('td-c', [_vm._v("鹿児島県")]) : _vm._e(), _vm._v(" "), (student.family.pref === 47) ? _c('td-c', [_vm._v("沖縄県")]) : _vm._e()], _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.family.address1) + _vm._s(student.family.address2))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.family.tel1))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(student.created_at.substring(0, 10)))])] : _vm._e()], 2)
  })], 2)], 1), _vm._v(" "), _c('h1', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "m-label m-label-custom",
    class: {
      'slideActive': _vm.column
    },
    on: {
      "click": function($event) {
        return _vm.switchV('column')
      }
    }
  }, [_vm._v("項目\n    "), _c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  }), _vm._v("ソート"), _c('i', {
    staticClass: "fa fa-fw fa-angle-down"
  }), _vm._v(" "), _c('span', [(this.sortColumn === 'id') ? [_vm._v("ID")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'company_id') ? [_vm._v("会社名")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'student_id') ? [_vm._v("生徒ID")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'student_name') ? [_vm._v("生徒")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'student_kana') ? [_vm._v("かな")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'month') ? [_vm._v("何月分")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'state') ? [_vm._v("現状")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'note') ? [_vm._v("備考")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'file_name') ? [_vm._v("ファイル名")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'points_english') ? [_vm._v("英語")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'points_mathematics') ? [_vm._v("数学")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'points_japanese') ? [_vm._v("国語")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'points_science') ? [_vm._v("理科")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'points_socialstudies') ? [_vm._v("社会")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'file') ? [_vm._v("ファイル")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'user') ? [_vm._v("登録者")] : _vm._e(), _vm._v(" "), (this.sortColumn === 'created_at') ? [_vm._v("作成日")] : _vm._e(), _vm._v("\n       : " + _vm._s(_vm.sortState) + "\n    ")], 2)]), _vm._v(" "), (_vm.column) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("RESET")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    nativeOn: {
      "click": function($event) {
        return _vm.all()
      }
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.id
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('id')
      }
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.company_id
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('company_id')
      }
    }
  }, [_vm._v("会社名")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.student_id
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('student_id')
      }
    }
  }, [_vm._v("生徒ID")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.student_name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('student_name')
      }
    }
  }, [_vm._v("生徒")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.student_kana
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('student_kana')
      }
    }
  }, [_vm._v("かな")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.month
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('month')
      }
    }
  }, [_vm._v("何月分")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.state
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('state')
      }
    }
  }, [_vm._v("現状")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.note
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('note')
      }
    }
  }, [_vm._v("備考")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.file_name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('file_name')
      }
    }
  }, [_vm._v("ファイル名")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.points_english
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('points_english')
      }
    }
  }, [_vm._v("英語")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.points_mathematics
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('points_mathematics')
      }
    }
  }, [_vm._v("数学")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.points_japanese
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('points_japanese')
      }
    }
  }, [_vm._v("国語")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.points_science
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('points_science')
      }
    }
  }, [_vm._v("理科")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.points_socialstudies
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('points_socialstudies')
      }
    }
  }, [_vm._v("社会")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.file
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('file')
      }
    }
  }, [_vm._v("ファイル")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.user
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('user')
      }
    }
  }, [_vm._v("登録者")]), _vm._v(" "), _c('btn', {
    staticClass: "m-btn--column",
    class: {
      'active': _vm.created_at
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchV('created_at')
      }
    }
  }, [_vm._v("作成日")])], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "StudentfilesIndex_upload",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('form', {
    staticClass: "upload_form",
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.postStudentfile($event)
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.student_id),
      expression: "studentfile.student_id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Student ID"
    },
    domProps: {
      "value": (_vm.studentfile.student_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "student_id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.month),
      expression: "studentfile.month"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": "",
      "maxlength": "7",
      "minlength": "7",
      "placeholder": "0001/01"
    },
    domProps: {
      "value": (_vm.studentfile.month)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "month", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.State,
      "label": "name",
      "show-labels": false,
      "placeholder": "現状"
    },
    model: {
      value: (_vm.watch.state),
      callback: function($$v) {
        _vm.$set(_vm.watch, "state", $$v)
      },
      expression: "watch.state"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.note),
      expression: "studentfile.note"
    }],
    staticClass: "note",
    attrs: {
      "type": "text",
      "placeholder": "備考"
    },
    domProps: {
      "value": (_vm.studentfile.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "note", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.fileName,
      "label": "name",
      "show-labels": false,
      "placeholder": "ファイル名"
    },
    model: {
      value: (_vm.watch.file_name),
      callback: function($$v) {
        _vm.$set(_vm.watch, "file_name", $$v)
      },
      expression: "watch.file_name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.selectedFile
    }
  })]), _vm._v(" "), _c('btn', {
    staticClass: "upload",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("アップロード")])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.points_english),
      expression: "studentfile.points_english"
    }],
    staticClass: "points",
    attrs: {
      "type": "text",
      "placeholder": "英語"
    },
    domProps: {
      "value": (_vm.studentfile.points_english)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "points_english", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.points_mathematics),
      expression: "studentfile.points_mathematics"
    }],
    staticClass: "points",
    attrs: {
      "type": "text",
      "placeholder": "数学"
    },
    domProps: {
      "value": (_vm.studentfile.points_mathematics)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "points_mathematics", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.points_japanese),
      expression: "studentfile.points_japanese"
    }],
    staticClass: "points",
    attrs: {
      "type": "text",
      "placeholder": "国語"
    },
    domProps: {
      "value": (_vm.studentfile.points_japanese)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "points_japanese", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.points_science),
      expression: "studentfile.points_science"
    }],
    staticClass: "points",
    attrs: {
      "type": "text",
      "placeholder": "理科"
    },
    domProps: {
      "value": (_vm.studentfile.points_science)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "points_science", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentfile.points_socialstudies),
      expression: "studentfile.points_socialstudies"
    }],
    staticClass: "points",
    attrs: {
      "type": "text",
      "placeholder": "社会"
    },
    domProps: {
      "value": (_vm.studentfile.points_socialstudies)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentfile, "points_socialstudies", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "index-box2 StudentfilesIndex",
    on: {
      "scroll": _vm.offset
    }
  }, [_c('table-c', [_c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('td-c'), _vm._v(" "), _c('td-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("検索")]), _vm._v(" "), (_vm.id) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.id),
      expression: "search.id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.company_id) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.company_id),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "company_id", $$v)
      },
      expression: "watchSearch.company_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.student_id) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.student_id),
      expression: "search.student_id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.student_id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "student_id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.student_name),
      expression: "search.student_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.student_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "student_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.student_kana),
      expression: "search.student_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.student_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "student_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.month),
      expression: "search.month"
    }],
    attrs: {
      "type": "text",
      "placeholder": "0001/01"
    },
    domProps: {
      "value": (_vm.search.month)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "month", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.State,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.state),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "state", $$v)
      },
      expression: "watchSearch.state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.note),
      expression: "search.note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.note)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "note", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.fileName,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.file_name),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "file_name", $$v)
      },
      expression: "watchSearch.file_name"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.points_english),
      expression: "search.points_english"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.points_english)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "points_english", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.points_mathematics),
      expression: "search.points_mathematics"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.points_mathematics)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "points_mathematics", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.points_japanese),
      expression: "search.points_japanese"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.points_japanese)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "points_japanese", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.points_science),
      expression: "search.points_science"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.points_science)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "points_science", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.points_socialstudies),
      expression: "search.points_socialstudies"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.points_socialstudies)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "points_socialstudies", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('td-c')] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.user),
      expression: "search.user"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.user)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "user", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.created_at),
      expression: "search.created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "created_at", $event.target.value)
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('td-c'), _vm._v(" "), _c('td-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("除外")]), _vm._v(" "), (_vm.id) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_id),
      expression: "search.not_id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.company_id) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.not_company_id),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "not_company_id", $$v)
      },
      expression: "watchSearch.not_company_id"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.student_id) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_student_id),
      expression: "search.not_student_id"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_student_id)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_student_id", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_student_name),
      expression: "search.not_student_name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_student_name)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_student_name", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_student_kana),
      expression: "search.not_student_kana"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_student_kana)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_student_kana", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_month),
      expression: "search.not_month"
    }],
    attrs: {
      "type": "text",
      "placeholder": "0001/01"
    },
    domProps: {
      "value": (_vm.search.not_month)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_month", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.State,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.not_state),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "not_state", $$v)
      },
      expression: "watchSearch.not_state"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_note),
      expression: "search.not_note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_note)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_note", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('td-c', {
    staticClass: "select"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.fileName,
      "label": "name",
      "placeholder": "",
      "show-labels": false
    },
    on: {
      "select": function($event) {
        return _vm.searchTable()
      }
    },
    model: {
      value: (_vm.watchSearch.not_file_name),
      callback: function($$v) {
        _vm.$set(_vm.watchSearch, "not_file_name", $$v)
      },
      expression: "watchSearch.not_file_name"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_points_english),
      expression: "search.not_points_english"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_points_english)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_points_english", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_points_mathematics),
      expression: "search.not_points_mathematics"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_points_mathematics)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_points_mathematics", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_points_japanese),
      expression: "search.not_points_japanese"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_points_japanese)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_points_japanese", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_points_science),
      expression: "search.not_points_science"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_points_science)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_points_science", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_points_socialstudies),
      expression: "search.not_points_socialstudies"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_points_socialstudies)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_points_socialstudies", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('td-c')] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_user),
      expression: "search.not_user"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_user)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_user", $event.target.value)
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('td-c', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.not_created_at),
      expression: "search.not_created_at"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.search.not_created_at)
    },
    on: {
      "keyup": function($event) {
        return _vm.searchTable()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "not_created_at", $event.target.value)
      }
    }
  })])] : _vm._e()], 2), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("削除")]), _vm._v(" "), _c('th-c', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("編集")]), _vm._v(" "), (_vm.id) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("id")
      }
    }
  }, [_vm._v("ID")])] : _vm._e(), _vm._v(" "), (_vm.company_id) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("company_id")
      }
    }
  }, [_vm._v("会社名")])] : _vm._e(), _vm._v(" "), (_vm.student_id) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_id")
      }
    }
  }, [_vm._v("Student ID")])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_name")
      }
    }
  }, [_vm._v("生徒")])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("student_kana")
      }
    }
  }, [_vm._v("生徒かな")])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("month")
      }
    }
  }, [_vm._v("何月分")])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("state")
      }
    }
  }, [_vm._v("現状")])] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("note")
      }
    }
  }, [_vm._v("備考")])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("file_name")
      }
    }
  }, [_vm._v("ファイル名")])] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_english")
      }
    }
  }, [_vm._v("英語")])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_mathematics")
      }
    }
  }, [_vm._v("数学")])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_japanese")
      }
    }
  }, [_vm._v("国語")])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_science")
      }
    }
  }, [_vm._v("理科")])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("points_socialstudies")
      }
    }
  }, [_vm._v("社会")])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("file")
      }
    }
  }, [_vm._v("ファイル")])] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("user")
      }
    }
  }, [_vm._v("User")])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('th-c', {
    nativeOn: {
      "click": function($event) {
        return _vm.sort("created_at")
      }
    }
  }, [_vm._v("作成日")])] : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.mapStudentfiles), function(list) {
    return _c('tr-c', {
      key: list.id,
      staticClass: "tr_hover StudentfilesIndex_upload",
      class: {
        'list-edit': list.id == _vm.edit_id.edit_id
      },
      attrs: {
        "slot": "tr-td"
      },
      slot: "tr-td"
    }, [(list.id == _vm.edit_id.edit_id) ? [_c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.cancelStudentfile(list)
        }
      }
    }, [_vm._v("戻る")]), _vm._v(" "), _c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.patchStudentfile(list)
        }
      }
    }, [_vm._v("更新")]), _vm._v(" "), (_vm.id) ? [_c('td-c', [_vm._v(_vm._s(list.id))])] : _vm._e(), _vm._v(" "), (_vm.company_id) ? [_c('td-c', [_vm._v(_vm._s(list.company))])] : _vm._e(), _vm._v(" "), (_vm.student_id) ? [_c('td-c', [_vm._v(_vm._s(list.student_id))])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('td-c', [_vm._v(_vm._s(list.student.f_name) + " " + _vm._s(list.student.l_name))])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('td-c', [_vm._v(_vm._s(list.student.f_name_kana) + " " + _vm._s(list.student.l_name_kana))])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.month),
        expression: "list.month"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.month)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "month", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.state) ? [_c('td-c', {
      staticClass: "select"
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.State,
        "label": "name",
        "show-labels": false,
        "placeholder": "現状"
      },
      model: {
        value: (_vm.watchPatch.state),
        callback: function($$v) {
          _vm.$set(_vm.watchPatch, "state", $$v)
        },
        expression: "watchPatch.state"
      }
    })], 1)] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('td-c', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.note),
        expression: "list.note"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "note", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [_c('td-c', {
      staticClass: "select"
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.fileName,
        "label": "name",
        "show-labels": false,
        "placeholder": "ファイル名"
      },
      model: {
        value: (_vm.watchPatch.file_name),
        callback: function($$v) {
          _vm.$set(_vm.watchPatch, "file_name", $$v)
        },
        expression: "watchPatch.file_name"
      }
    })], 1)] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_english),
        expression: "list.points_english"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_english)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_english", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_mathematics),
        expression: "list.points_mathematics"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_mathematics)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_mathematics", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_japanese),
        expression: "list.points_japanese"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_japanese)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_japanese", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_science),
        expression: "list.points_science"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_science)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_science", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('td-c', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.points_socialstudies),
        expression: "list.points_socialstudies"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (list.points_socialstudies)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(list, "points_socialstudies", $event.target.value)
        }
      }
    })])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('td-c', [_c('form', {
      staticClass: "update_form",
      attrs: {
        "enctype": "multipart/form-data"
      }
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": "file"
      },
      on: {
        "change": _vm.patchSelectedFile
      }
    })])])] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('td-c', [_vm._v(_vm._s(list.user.user))])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('td-c', [_vm._v(_vm._s(list.created_at.substring(0, 10)))])] : _vm._e()] : _vm._e(), _vm._v(" "), (list.id !== _vm.edit_id.edit_id) ? [_c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.deleteStudentfile(list)
        }
      }
    }, [_vm._v("削除")]), _vm._v(" "), _c('td-c', {
      staticClass: "del",
      nativeOn: {
        "click": function($event) {
          return _vm.edit(list)
        }
      }
    }, [_vm._v("編集")]), _vm._v(" "), (_vm.id) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.id))])] : _vm._e(), _vm._v(" "), (_vm.company_id) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.company))])] : _vm._e(), _vm._v(" "), (_vm.student_id) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student_id))])] : _vm._e(), _vm._v(" "), (_vm.student_name) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student.f_name) + " " + _vm._s(list.student.l_name))])] : _vm._e(), _vm._v(" "), (_vm.student_kana) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.student.f_name_kana) + " " + _vm._s(list.student.l_name_kana))])] : _vm._e(), _vm._v(" "), (_vm.month) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.month))])] : _vm._e(), _vm._v(" "), (_vm.state) ? [(list.state === 0) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (list.state === 1) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("提出済")]) : _vm._e(), _vm._v(" "), (list.state === 2) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("連絡済")]) : _vm._e(), _vm._v(" "), (list.state === 3) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("未提出")]) : _vm._e(), _vm._v(" "), (list.state === 4) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("テキスト未使用")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.note) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.note))])] : _vm._e(), _vm._v(" "), (_vm.file_name) ? [(list.file_name === 0) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("未選択")]) : _vm._e(), _vm._v(" "), (list.file_name === 1) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("指導報告書")]) : _vm._e(), _vm._v(" "), (list.file_name === 2) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v("引継文章")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.points_english) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_english))])] : _vm._e(), _vm._v(" "), (_vm.points_mathematics) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_mathematics))])] : _vm._e(), _vm._v(" "), (_vm.points_japanese) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_japanese))])] : _vm._e(), _vm._v(" "), (_vm.points_science) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_science))])] : _vm._e(), _vm._v(" "), (_vm.points_socialstudies) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.points_socialstudies))])] : _vm._e(), _vm._v(" "), (_vm.file) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    })] : _vm._e(), _vm._v(" "), (_vm.user) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.user.user))])] : _vm._e(), _vm._v(" "), (_vm.created_at) ? [_c('a', {
      staticClass: "link",
      attrs: {
        "href": _vm.linkStudentfile(list),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.created_at.substring(0, 10)))])] : _vm._e()] : _vm._e()], 2)
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adde31b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Studentfiles/StudentfilesIndex.vue
// module id = 1442
// module chunks = 0